export enum ReceiptNoteType {
    Demands = 'demands',
    Inquiries = 'inquiries',
    Invoices = 'invoices',
    PurchaseOrders = 'purchase-orders',
    SalesOrders = 'sales-orders',
}
